/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
export function find(list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
export function formatToMoney(value) {
  if (value) {
    return value.format(2, 3, '.', ',');
  }
}
export function formatToDecimal(value) {
  if (value) {
    return value.replace(".", "").replace(",", ".");
  }
}

// Takı ürün adları kataloğu. Takı Ekle ekranındaki (Index.vue takiProducts) liste ile aynı tutulmalı.
// Reçete (Product Detail) takı bileşeni seçiminde de kullanılır.
export const takiProducts = [
  "Bilezik",
  "Burma Bilezik",
  "2li Burma Bilezik",
  "3lü Burma Bilezik",
  "2li Burma Çocuk Bilezik",
  "3lü Burma Çocuk Bilezik",
  "Setina Çocuk Bilezik",
  "Ajda Bilezik",
  "Oluklu Ajda Bilezik",
  "Tel Bilezik",
  "Setina Bilezik",
  "Taşlı Kolye",
  "Küpe",
  "Küpe Ucu",
];
Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}
String.prototype.format = function (n, x, s, c) {
  var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
    num = parseFloat(this).toFixed(Math.max(0, ~~n));

  return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};



export function deepCopy(obj, cache = []) {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  const hit = find(cache, c => c.original === obj)
  if (hit) {
    return hit.copy
  }

  const copy = Array.isArray(obj) ? [] : {}
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy
  })

  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache)
  })

  return copy
}
/* eslint-disable no-extend-native */

String.prototype.hashCode = function hashCode() {
  let hash = 0;
  let i;
  let chr;
  if (this.length === 0) return hash;
  for (i = 0; i < this.length; i++) {
    chr = this.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};


String.prototype.dataUrlToFile = function dataUrlToFile() {
  const arr = this.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n) {
    n -= 1;
    u8arr[n] = bstr.charCodeAt(n);
  }

  const filename = `${Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)}.${mime.split('/')[1]}`;
  return new File([u8arr], filename, {
    type: mime
  });
};

/**
 * forEach for object
 */
export function forEachValue(obj, fn) {
  Object.keys(obj).forEach(key => fn(obj[key], key))
}

export function isObject(obj) {
  return obj !== null && typeof obj === 'object'
}

String.prototype.isNumeric = function (n) {
  n = n.replace(",", "");
  return !isNaN(parseFloat(n)) && isFinite(n);
}


export function isPromise(val) {
  return val && typeof val.then === 'function'
}

export function assert(condition, msg) {
  if (!condition) throw new Error(`[vuex] ${msg}`)
}
Number.prototype.format = function (n, x, s, c) {
  var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
    num = this.toFixed(Math.max(0, ~~n));

  return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
};
export function partial(fn, arg) {
  return function () {
    return fn(arg)
  }
}